import request from '@/utils/request'

/**
 * 添加应用与组织成员关系
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appOrgMemberListAdd(data) {
  return request({
    type: 'base',
    url: 'app/org/member/list/add',
    method: 'post',
    data
  })
}
/**
 * 获取拥有应用授权的组织成员列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appOrgMemberListGet(data) {
  return request({
    type: 'base',
    url: 'app/org/member/list/get',
    method: 'post',
    data
  })
}
/**
 * 编辑应用与组织成员关系（覆盖原有关系）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appOrgMemberListUpdate(data) {
  return request({
    type: 'base',
    url: 'app/org/member/list/update',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/AppOrgMember.js